import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import reduxUtils from 'util/redux';
import mapFacets from 'util/react/facet';
import { connect } from 'react-redux';

class Card extends PureComponent {
    static defaultProps = {
        facet: 'base',
    };

    static propTypes = {
        children: PropTypes.any,
        facet: PropTypes.any,
    };

    render() {
        const { children, facet } = this.props;

        return (
            <article className={classnames('card', mapFacets(facet, 'card'))}>
                <div className="card--background">
                    {children && <div className="card--inner">
                        {children}
                    </div>}
                </div>
            </article>
        );
    };
};

export default connect(
    reduxUtils.mapStateToProps({})
)(Card);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/card-stack/card/index.js